export const getStatusAttendanceColor = (status) => {
  switch (status) {
    case 'ONTIME':
      return {
        text: 'var(--color-accent-content-green)',
        bg: 'var(--color-accent-foreground-green)'
      }
    case 'LATE':
      return {
        text: 'var(--color-functional-foreground-warning)',
        bg: 'var(--color-functional-foreground-warning-subtle)'
      }
    case 'LEAVE':
      return {
        text: 'var(--color-on-base-content-subtle)',
        bg: 'var(--color-on-base-foreground-default)'
      }
    case 'NO_SHIFT':
      return {
        text: 'var(--color-on-base-content-subtle)',
        bg: 'var(--color-on-base-foreground-default)'
      }
    case 'NO_SHOW':
      return {
        text: 'var(--color-on-base-content-subtle)',
        bg: 'var(--color-on-base-foreground-default)'
      }
    case 'ABSENT':
      return {
        text: 'var(--color-accent-content-red)',
        bg: 'var(--color-accent-foreground-red)'
      }
    case 'ONTIME_EARLY':
      return {
        text: 'var(--color-functional-foreground-info)',
        bg: 'var(--color-functional-foreground-info-subtle)'
      }
    case 'LATE_EARLY':
      return {
        text: 'var(--color-accent-content-violet)',
        bg: 'var(--color-accent-foreground-violet)'
      }
    case 'WORK_HOLIDAY':
      return {
        text: 'var(--color-accent-content-pink)',
        bg: 'var(--color-accent-foreground-pink)'
      }
    case 'DAYOFF':
      return {
        text: 'var(--color-on-base-content-subtle)',
        bg: 'var(--color-base-foreground-disable)'
      }
    case 'OFFSITE':
      return {
        text: 'var(--color-palette-orange-400)',
        bg: 'var(--color-accent-foreground-orange)'
      }
    default:
      return {
        text: 'var(--color-on-base-content-subtle)',
        bg: 'var(--color-on-base-foreground-default)'
      }
  }
}
